import { Button } from '@exam-prep/ui';
import { type CardFace, type Rating, RATING_BUTTONS } from '../model/flow';

/** One card: tap the front to show the back. Copy deterrents as on exam screens. */
export function CardView({
  card,
  flipped,
  onFlip,
}: {
  card: CardFace;
  flipped: boolean;
  onFlip: () => void;
}) {
  return (
    <button
      type="button"
      className="flashcard w-full rounded-2xl border bg-card p-6 text-left shadow-sm select-none"
      aria-label={flipped ? 'Answer' : 'Question. Tap to show the answer'}
      onClick={onFlip}
      onContextMenu={(e) => e.preventDefault()}
      data-testid="flashcard"
    >
      <p className="text-xs tracking-wide text-muted-foreground uppercase">
        {card.deckTitle}
        {card.isNew ? ' · new' : ''}
      </p>
      <p className="mt-3 text-lg font-semibold whitespace-pre-wrap">{card.front}</p>
      {flipped ? (
        <p className="mt-4 border-t pt-4 whitespace-pre-wrap">{card.back}</p>
      ) : (
        <p className="mt-4 text-sm text-muted-foreground">Tap to show the answer</p>
      )}
    </button>
  );
}

export function RatingBar({
  onRate,
  disabled,
}: {
  onRate: (r: Rating) => void;
  disabled: boolean;
}) {
  return (
    <div className="grid grid-cols-4 gap-2" role="group" aria-label="How well did you know it?">
      {RATING_BUTTONS.map((b) => (
        <Button
          key={b.rating}
          variant={b.rating === 3 ? 'default' : 'outline'}
          disabled={disabled}
          onClick={() => onRate(b.rating)}
          className="flex h-auto flex-col py-2"
        >
          <span>{b.label}</span>
          <span className="text-[10px] opacity-70">{b.hint}</span>
        </Button>
      ))}
    </div>
  );
}
